export { default } from './RegistrationPayment'



// WEBPACK FOOTER //
// ./src/App/pages/EventRegistration/RegistrationPayment/index.js